<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.provider_edit") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #F7941E">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- <base-image-upload-input
            col="12"
            :identifier="data.image.path.endsWith('.mp4') ? 'video' : 'image'"
            :placeholder="$t('PLACEHOLDERS.contents')"
            @selectImage="selectImage"
            required
            :preSelectedImage="data.image.path"
          /> -->

          <!-- <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.user_name')"
            v-model.trim="data.user_name"
            required
          /> -->
          <!-- End:: Ar Name Input -->

          <!-- Start:: En Name Input -->
          <!-- <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.phone')"
            v-model.trim="data.phone"
            required
          /> -->
          <!-- <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.email')"
            v-model.trim="data.email"
            required
          /> -->

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameAr')"
            v-model.trim="data.name_ar"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameEn')"
            v-model.trim="data.name_en"
            required
          />

          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descriptionAr')"
            v-model.trim="data.desc_ar"
            required
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descriptionEn')"
            v-model.trim="data.desc_en"
            required
          />

          <base-input
            col="12"
            type="text"
            :placeholder="$t('PLACEHOLDERS.commercial_register')"
            v-model.trim="data.commercial_register"
            required
          />

          <base-image-upload-input
            col="4"
            identifier="image1"
            :placeholder="$t('PLACEHOLDERS.commercial_register_image')"
            @selectImage="selectImage1"
            required
            :preSelectedImage="data.commercial_register_image.path"
          />

          <base-image-upload-input
            col="4"
            identifier="image2"
            :placeholder="$t('PLACEHOLDERS.tax_file')"
            @selectImage="selectImage2"
            required
            :preSelectedImage="data.tax_file.path"
          />

          <base-image-upload-input
            col="4"
            identifier="image3"
            :placeholder="$t('PLACEHOLDERS.license')"
            @selectImage="selectImage3"
            required
            :preSelectedImage="data.license.path"
          />

          <base-select-input
            col="6"
            :optionsList="types"
            :placeholder="$t('PLACEHOLDERS.commission_type')"
            v-model="data.commission_type"
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.presintage')"
            v-model.trim="data.presintage"
            required
          />
          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import BaseImageUploadInput from "../../../components/formInputs/BaseImageUploadInput.vue";
import moment from "moment";

export default {
  name: "EditAds",

  components: { BaseImageUploadInput },

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      file: null,
      fileType: "",

      // Start:: Data Collection To Send
      data: {
        commercial_register_image: {
          path: null,
          file: null,
        },
        tax_file: {
          path: null,
          file: null,
        },
        license: {
          path: null,
          file: null,
        },
        user_name: null,
        name_ar: null,
        name_en: null,
        desc_ar: null,
        desc_en: null,
        phone: null,
        email: null,
        commercial_register: null,
        commission_type: null,
        presintage: null,
      },
      // End:: Data Collection To Send

      arabicRegex: /^[\u0600-\u06FF\s]+$/,
      EnRegex: /[\u0600-\u06FF]/,
    };
  },

  computed: {
    types() {
      return [
        {
          id: 1,
          name: this.$t("PLACEHOLDERS.flat"),
          value: "flat",
        },
        {
          id: 2,
          name: this.$t("PLACEHOLDERS.percentage"),
          value: "percentage",
        },
      ];
    },
  },

  methods: {
    selectImage1(selectedImage1) {
      this.data.commercial_register_image = selectedImage1;
    },
    selectImage2(selectedImage2) {
      this.data.tax_file = selectedImage2;
    },
    selectImage3(selectedImag3) {
      this.data.license = selectedImag3;
    },

    disabledDate(current) {
      return current && current < moment().startOf("day");
    },

    onCopy(event) {
      event.preventDefault();
    },
    onPaste(event) {
      event.preventDefault();
    },

    validateInput() {
      // Remove non-Arabic characters from the input
      this.data.nameAr = this.data.nameAr.replace(/[^\u0600-\u06FF\s]/g, "");
    },
    removeArabicCharacters() {
      this.data.nameEn = this.data.nameEn.replace(this.EnRegex, "");
    },

    handleFileSelected({ file, fileType }) {
      this.file = file; // Store the selected file in your data
      this.fileType = fileType; // Store the selected file in your data
    },
    handleFileRemoved() {
      this.file = null; // Reset the file when it's removed
      this.fileType = "";
    },

    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;

      this.submitForm();
    },
    // End:: validate Form Inputs

    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();
      REQUEST_DATA.append("commission_type", this.data.commission_type?.value);
      REQUEST_DATA.append("commission_value", this.data.presintage);
      REQUEST_DATA.append("name[ar]", this.data.name_ar);
      REQUEST_DATA.append("name[en]", this.data.name_en);
      REQUEST_DATA.append("description[ar]", this.data.desc_ar);
      REQUEST_DATA.append("description[en]", this.data.desc_en);
      REQUEST_DATA.append(
        "commercial_registration_number",
        this.data.commercial_register
      );

      if (this.data.commercial_register_image.file) {
        REQUEST_DATA.append(
          "commercial_registration_file",
          this.data.commercial_register_image.file
        );
      }
      if (this.data.tax_file.file) {
        REQUEST_DATA.append("vat_certificate_file", this.data.tax_file.file);
      }
      if (this.data.license.file) {
        REQUEST_DATA.append("municipal_license_file", this.data.license.file);
      }
      REQUEST_DATA.append("_method", "PUT");

      try {
        await this.$axios({
          method: "POST",
          url: `providers/${this.$route.params.id}`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
        this.$router.push({ path: "/providers/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form

    // start all ads data
    async getAdsData() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `providers/${this.$route.params.id}`,
        });
        this.data.name_ar = res.data.data.data.shop.name_ar;
        this.data.name_en = res.data.data.data.shop.name_en;
        this.data.desc_ar = res.data.data.data.shop.description_ar;
        this.data.desc_en = res.data.data.data.shop.description_en;
        this.data.phone = res.data.data.data.mobile;
        this.data.email = res.data.data.data.email;
        this.data.commercial_register =
          res.data.data.data.shop?.commercial_registration_number;
        this.data.commercial_register_image.path =
          res.data.data.data.shop?.commercial_registration_file;
        this.data.tax_file.path = res.data.data.data.shop?.vat_certificate_file;
        this.data.license.path =
          res.data.data.data.shop?.municipal_license_file;
        this.data.commission_type =
          res.data.data.data.commission_type == "flat"
            ? {
                id: 1,
                name: this.$t("PLACEHOLDERS.flat"),
                value: "flat",
              }
            : {
                id: 2,
                name: this.$t("PLACEHOLDERS.percentage"),
                value: "percentage",
              };
        this.data.presintage = res.data.data.data.commission_value;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    // end all ads data
  },

  created() {
    // Start:: Fire Methods
    this.getAdsData();
    // End:: Fire Methods
  },
};
</script>

<style>
.preview-container img,
.preview-container video {
  max-width: 100%;
  max-height: 200px;
  border: 1px solid #ccc;
}
</style>
